import React from "react";
import { useHistory } from "react-router-dom";
import styled from "@emotion/styled";
import { ContentContainer } from "../../routes/Landing.style";

const TermsOfServicePage = () => {
  const history = useHistory();

  return (
    <PageContainer>
      <ContentContainer>
        <PageContent>
          <Header>
            <Title>서비스 이용약관</Title>
            <BackButton onClick={() => history.goBack()}>✕</BackButton>
          </Header>
          <Content>
            <Section>
              <SectionTitle>취소 및 환불 규정</SectionTitle>
              <Paragraph>
                본 서비스는 「전자상거래 등에서의 소비자보호에 관한 법률」 제17조에 따라 결제일로부터 7일 이내에는 청약철회를 요청할 수 있습니다.
                다만, 아래의 경우에는 청약철회가 제한될 수 있습니다.
              </Paragraph>
              <List>
                <ListItem>결제 후 서비스가 즉시 제공되거나, 법률상담 또는 서류작성 등 용역의 제공이 이미 개시된 경우</ListItem>
                <ListItem>이용자의 동의 하에 서비스가 진행되어 사실상 회수가 불가능한 경우</ListItem>
                <ListItem>기타 「전자상거래 등에서의 소비자보호에 관한 법률」 및 관련 법령에서 정한 청약철회 제한 사유에 해당하는 경우</ListItem>
              </List>
              <Paragraph>
                환불이 가능한 경우, 환불은 청약철회 접수일로부터 3~7영업일 이내에 PG사(카카오페이 등)를 통해 처리됩니다.
                자세한 내용은 고객센터 또는 1:1 문의를 통해 안내받으실 수 있습니다.
              </Paragraph>
            </Section>

            <Section>
              <SectionTitle>제1조(청약철회 및 환불)</SectionTitle>
              <Paragraph>
                ① 이용자는 「전자상거래 등에서의 소비자보호에 관한 법률」 제17조에 따라 결제일로부터 7일 이내 청약철회를 요청할 수 있습니다.
              </Paragraph>
              <Paragraph>
                ② 다만, 다음 각 호의 어느 하나에 해당하는 경우에는 청약철회가 제한됩니다.
              </Paragraph>
              <List>
                <ListItem>결제 후 법률상담, 문서작성 등 서비스 제공이 이미 개시된 경우</ListItem>
                <ListItem>서비스 특성상 회수 또는 재이용이 불가능한 경우</ListItem>
                <ListItem>기타 관련 법령에 따라 청약철회가 제한되는 경우</ListItem>
              </List>
              <Paragraph>
                ③ 회사는 이용자의 청약철회 요청이 정당하다고 인정될 경우, 해당 결제금액을 3~7영업일 이내에 환불합니다. 환불은 결제수단을 통해 처리되며, PG사(카카오페이 등)의 환불 정책을 따릅니다.
              </Paragraph>
              <Paragraph>
                ④ 환불 요청 및 관련 문의는 고객센터 또는 1:1 문의를 통해 접수할 수 있습니다.
              </Paragraph>
            </Section>
          </Content>
        </PageContent>
      </ContentContainer>
    </PageContainer>
  );
};

const PageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: #ffffff;
  padding: 20px 0;
`;

const PageContent = styled.div`
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
  background: #ffffff;
  padding: 24px;
  box-sizing: border-box;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e0e0e0;
`;

const Title = styled.h2`
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  color: #000;
`;

const BackButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Content = styled.div`
  width: 100%;
`;

const Section = styled.div`
  margin-bottom: 32px;
`;

const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
  color: #000;
`;

const Paragraph = styled.p`
  font-size: 14px;
  line-height: 1.8;
  color: #333;
  margin-bottom: 12px;
  white-space: pre-wrap;
`;

const List = styled.ul`
  font-size: 14px;
  line-height: 1.8;
  color: #333;
  padding-left: 20px;
  margin-bottom: 12px;
`;

const ListItem = styled.li`
  margin-bottom: 8px;
`;

export default TermsOfServicePage;

